import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import * as _ from "lodash";

export class QualificationHistory {
  currentHE: apsViewModels.QualificationActivity;
  currentCE: apsViewModels.QualificationActivity;
  heIsQualified: boolean;
  ceIsQualified: boolean;
  private hotEndQualifications: apsViewModels.QualificationActivity[];
  private coldEndQualifications: apsViewModels.QualificationActivity[];

  constructor() {
    this.hotEndQualifications = [];
    this.coldEndQualifications = [];
  }

  heQualifications(): apsViewModels.QualificationActivity[] {
    return QualificationHistory.sortQualifications(this.hotEndQualifications);
  }

  ceQualifications(): apsViewModels.QualificationActivity[] {
    return QualificationHistory.sortQualifications(this.coldEndQualifications);
  }

  addQualification(qualification: apsViewModels.QualificationActivity) {
    switch (qualification.location) {
      case apsEnums.Location.HotEnd:
        this.hotEndQualifications.unshift(qualification);
        this.currentHE = QualificationHistory.getCurrent(this.hotEndQualifications);
        this.heIsQualified = QualificationHistory.isQualified(this.currentHE);
        break;
      case apsEnums.Location.ColdEnd:
        this.coldEndQualifications.unshift(qualification);
        this.currentCE = QualificationHistory.getCurrent(this.coldEndQualifications);
        this.ceIsQualified = QualificationHistory.isQualified(this.currentCE);
        break;
      default:
        throw 'Invalid Qualification PlantLocation';
    }
  }

  deleteQualification(qualification: apsViewModels.QualificationActivity) {
    switch (qualification.location) {
      case apsEnums.Location.HotEnd:
        _.remove(this.hotEndQualifications, (q: apsViewModels.QualificationActivity) => { return q.id === qualification.id; });
        this.currentHE = QualificationHistory.getCurrent(this.hotEndQualifications);
        this.heIsQualified = QualificationHistory.isQualified(this.currentHE);
        break;
      case apsEnums.Location.ColdEnd:
        _.remove(this.coldEndQualifications, (q: apsViewModels.QualificationActivity) => { return q.id === qualification.id; });
        this.currentCE = QualificationHistory.getCurrent(this.coldEndQualifications);
        this.ceIsQualified = QualificationHistory.isQualified(this.currentCE);
        break;
      default:
        throw 'Invalid Qualification PlantLocation';
    }
  }

  private static sortQualifications(qualifications: apsViewModels.QualificationActivity[]): apsViewModels.QualificationActivity[] {
    return _.orderBy(qualifications, ['qualificationTime', 'status'], ['desc', 'asc']);
  }

  private static getCurrent(qualifications: apsViewModels.QualificationActivity[]): apsViewModels.QualificationActivity {
    return _.first(QualificationHistory.sortQualifications(qualifications));
  }

  private static isQualified(qualification: apsViewModels.QualificationActivity) {
    if (qualification) {
      return qualification.status === apsEnums.QualificationStatus.Qualified;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/activity/qualificationHistory.ts